(() => {
  if (window.PlanetaHeaderIconFit) {
    window.PlanetaHeaderIconFit(document);
    return;
  }

  async function fitImage(image) {
    const viewport = image.closest('.header__icon-viewport, .p3d-floating-menu__media');
    if (!viewport) return;
    const url = image.currentSrc || image.src;
    if (image.dataset.fittedSource === url) return;
    const source = new Image();
    source.crossOrigin = 'anonymous';
    source.src = url;
    try {
      await source.decode();
      if (!image.isConnected || (image.currentSrc || image.src) !== url) return;

      const side = 256;
      const scale = side / Math.max(source.naturalWidth, source.naturalHeight);
      const width = Math.max(1, Math.round(source.naturalWidth * scale));
      const height = Math.max(1, Math.round(source.naturalHeight * scale));
      const canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      context.drawImage(source, 0, 0, width, height);
      const pixels = context.getImageData(0, 0, width, height).data;
      const corners = [0, width - 1, (height - 1) * width, height * width - 1];
      const background = [0, 1, 2].map(channel =>
        corners.reduce((sum, index) => sum + pixels[index * 4 + channel], 0) / 4
      );
      const opaqueBackground = corners.every(index =>
        pixels[index * 4 + 3] > 245 &&
        background.every((value, channel) => Math.abs(value - pixels[index * 4 + channel]) < 20)
      );

      let left = width, top = height, right = -1, bottom = -1;
      for (let y = 0; y < height; y++) {
        for (let x = 0; x < width; x++) {
          const index = (y * width + x) * 4;
          if (pixels[index + 3] < 24) continue;
          if (opaqueBackground && [0, 1, 2].every(channel =>
            Math.abs(pixels[index + channel] - background[channel]) < 34
          )) continue;
          left = Math.min(left, x);
          right = Math.max(right, x);
          top = Math.min(top, y);
          bottom = Math.max(bottom, y);
        }
      }
      if (right < left) return;

      const visibleSide = Math.max(right - left + 1, bottom - top + 1);
      const productHandle = image.closest('[data-product-handle]')?.dataset.productHandle;
      const subjectSize = ['p1s-de-bambu-lab-precision-velocidad-y-estilo-en-casa', 'preventa-bambu-lab-p2s-256-256-256-mm', 'bambu-lab-x2d-pre-venta-impresion-3d-de-doble-boquilla'].includes(productHandle) ? 71.2 : 86;
      const imageSize = subjectSize * Math.max(width, height) / visibleSide;
      const centerX = (left + right + 1) / 2;
      const centerY = (top + bottom + 1) / 2;
      image.style.width = `${imageSize}%`;
      image.style.height = `${imageSize}%`;
      image.style.left = `${50 - (centerX - width / 2) * imageSize / Math.max(width, height)}%`;
      image.style.top = `${50 - (centerY - height / 2) * imageSize / Math.max(width, height)}%`;
      viewport.dataset.fitted = 'true';
      image.dataset.fittedSource = url;
    } catch (_) {
      // An image host without canvas permission still displays at the shared base size.
      if (viewport.classList.contains('p3d-floating-menu__media')) {
        ['width', 'height', 'left', 'top'].forEach(property => image.style.removeProperty(property));
        delete viewport.dataset.fitted;
        delete image.dataset.fittedSource;
      }
    }
  }

  function fit(root) {
    root.querySelectorAll('.header__icon-viewport > img.header__custom-icon, [data-p3d-menu-title="impresoras"] .p3d-floating-menu__media > img.p3d-floating-menu__image').forEach(image => {
      if (!image.closest('.header-section')) return;
      const iconViewport = image.closest('.header__icon-viewport');
      if (iconViewport) {
        if (iconViewport.dataset.fitted !== 'true') fitImage(image);
        return;
      }
      if (!image.dataset.navFitBound) {
        image.dataset.navFitBound = 'true';
        image.addEventListener('load', () => fitImage(image));
      }
      if (image.complete && image.naturalWidth) fitImage(image);
    });
  }

  window.PlanetaHeaderIconFit = fit;
  fit(document);
  document.addEventListener('shopify:section:load', event => fit(event.target));
})();
